import { render, staticRenderFns } from "./NotesListView.html?vue&type=template&id=d9811ca4&"
import script from "./NotesListView.component.js?vue&type=script&lang=js&"
export * from "./NotesListView.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports